import {IFormSubmitAction, IPayloadAction, IAction} from 'core/store'
import * as actionTypes from './actionTypes'

interface IActionRegisterRequestPayload {
  firstName?: string
  lastName?: string
  npi?: string
  confirmNpi?: string
  email: string
  password?: string
  isApproved?: boolean
  approvedTime?: Date
}

interface IActionApproveRequestPayload{
  email: string
  isApproved: boolean
  id: string
  approvedTime: string
  confirmPassword?: string
}
export interface IActionRegisterRequest extends
  IFormSubmitAction<typeof actionTypes.REGISTER_FORM_NAME, IActionRegisterRequestPayload> {}
export const registerRequest = (payload: IActionRegisterRequestPayload, formName: string): IActionRegisterRequest => ({
  type: actionTypes.REGISTER_FORM_NAME,
  payload,
  form: formName,
})

export interface IActionApproveRequest extends
  IFormSubmitAction<typeof actionTypes.APPROVE_FORM_NAME, IActionApproveRequestPayload> {}
export const approveRequest = (id: string, payload: IActionApproveRequestPayload, formName: string): IActionApproveRequest => ({
  type: actionTypes.APPROVE_FORM_NAME,
  payload,
  form: formName,
})

export interface IActionPasswordRequest extends
  IFormSubmitAction<typeof actionTypes.PASSWORD_FORM_NAME, IActionApproveRequestPayload> {}
export const changePasswordRequest = (id: string, payload: IActionApproveRequestPayload, formName: string): IActionPasswordRequest => ({
  type: actionTypes.PASSWORD_FORM_NAME,
  payload,
  form: formName,
})

interface IActionDeleteRequestPayload{
  id: string
}
export interface IActionDeleteRequest extends
  IFormSubmitAction<typeof actionTypes.DELETE_REQUEST_FORM_NAME, IActionDeleteRequestPayload> {}
export const deleteRequest = (payload: IActionDeleteRequestPayload, formName: string): IActionDeleteRequest => ({
  type: actionTypes.DELETE_REQUEST_FORM_NAME,
  payload,
  form: formName,
})

interface IActionCreateAccountRequestPayload {
  firstName: string
  lastName: string
  password: string
  registrationCode: string
}
export interface IActionCreateAccountRequest extends
  IFormSubmitAction<typeof actionTypes.CREATE_ACCOUNT_FORM_NAME, IActionCreateAccountRequestPayload> {}
export const createAccountRequest = (payload: IActionCreateAccountRequestPayload, formName: string): IActionCreateAccountRequest => ({
  type: actionTypes.CREATE_ACCOUNT_FORM_NAME,
  payload,
  form: formName,
})

export interface IActionSetHasCreatedAccount extends IPayloadAction<typeof actionTypes.SET_HAS_CREATED_ACCOUNT, boolean> {}
export const setHasCreatedAccount = (hasCreatedAccount: boolean): IActionSetHasCreatedAccount => ({
  type: actionTypes.SET_HAS_CREATED_ACCOUNT,
  payload: hasCreatedAccount,
})

export interface IActionResetHasCreatedAccount extends
  IAction<typeof actionTypes.RESET_HAS_CREATED_ACCOUNT> {}
export const resetHasCreatedAccount = (): IActionResetHasCreatedAccount => ({
  type: actionTypes.RESET_HAS_CREATED_ACCOUNT,
})

export type TAction =
  IActionRegisterRequest |
  IActionCreateAccountRequest |
  IActionSetHasCreatedAccount |
  IActionResetHasCreatedAccount



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/register/actions.ts